module.exports = __webpack_public_path__ + "img/rounded-sick.5c65fccb.svg";